/* -- Barcode scanning rules 02.11.17 --
 *
 * IF scan ends with period . THEN intercept value from intended use
 *    IF value decodes base64 and STARTS with # THEN send Trigger "click"
 *    IF value decodes base64 NOT containing # THEN parse href redirection
 *
 * ALL other scan values are intended for field capture
 */
$(document).ready(function () {
    var $body = $("body");

    $("ul.paging li.select select").on("change", function (e) {
        window.location = $(this).val();
    });

    var hash = window.location.hash;
    hash && $('ul.nav a[href="' + hash + '"]').tab('show');


    /**
     * Page Specific Actions
     */
    switch ($body.attr("id")) {
        case "page-salesorder-browse":
            document.querySelector('#filter_date_period').addEventListener('change', function () {
                const date = document.querySelector('#filter_date_specified');
                date.disabled = this.value !== 'Specified Date';
                this.value === 'Specified Date' ? date.classList.remove('hide') : date.classList.add('hide');
            });
            break;
        case "page-salesorder-details":
            // Apply table check-all function
            document.querySelectorAll('table').forEach(function (table) {
                _tableFunctions($(table));
            });
            //Multiple tab toggles - does not work with ul.nav.nav-tabs/li
            document.querySelectorAll('[data-toggle="tab"]').forEach(link => link.addEventListener('click', function (e) {
                document.querySelectorAll('[data-toggle="tab"]').forEach(toggle => toggle.href === link.href ? toggle.parentElement.classList.add('active') : toggle.parentElement.classList.remove('active'));
            }));
            break;
        default:
            break;
    }// END SWITCH


    /**
     * COMMON functions
     * ===================================================
     */
    if (typeof document.getElementById("backBtn") === 'undefined' || document.getElementById("backBtn") === null) {
        // console.log("back button not found");
        // Do nothing
    } else {
        $("#backBtn").click(function () {
            window.history.back();
        });
    }

    function reloadWin() {
        var w = window.open("", "main"); //get handle of "main"
        w.location.reload(true);  //reload it
    }

    /**
     * MENU
     */

    $('.menu-open').click(function () {
        $('#menu').toggleClass('open');
    })

    /**
     * MESSAGES & ALERT functions
     * ===================================================
     */
    var $messages = $('#messages, .messages');
    $messages.find('.message-close').on('click', function (e) {
        $messages.hide();
    });

    function displayMessageBox(message, type, appendFieldset, focusField, _callback) {
        // $(".msgBox .close-icon").hide();

        var $msgBox = $(".msgBox");
        switch (type) {
            case "warning":
                $msgBox.removeClass("success");
                $msgBox.find(".sprite").removeClass("success-icon").addClass("caution-icon");
                break;
            case "success":
                $msgBox.removeClass("warning");
                $msgBox.find(".sprite").removeClass("caution-icon").addClass("success-icon");
                break;
            default:
                break;
        }// end switch

        // Default
        $msgBox.detach();
        $msgBox.appendTo(appendFieldset);

        var icon = '<div class="sprite pull-left"></div>';
        $msgBox.find(".message").html(icon + message);
        $msgBox.removeClass("hide").addClass(type);
        $msgBox.show();

        $(".msgBox .close-icon, .msgBox .btn-danger").click(function (e) {
            $(this).closest('.msgBox').hide();
            // $(hideFieldset).show();

            if (focusField != null) {
                if (focusField != "#serial_confirm")
                    $(focusField).attr('value', '');

                $(focusField).show();
            }
        });


        setTimeout(function () {
            $(focusField).focus().select();
        }, 100);
    }// end function

    function scrollToAnchor(aid) {
        var aTag = $("a[name='" + aid + "']");
        $("html, body").animate({
            scrollTop: aTag.offset().top
        }, 'fast');
    }

    function scrollToBottom() {
        $("html, body").animate({scrollTop: $(document).height()}, "fast");
    }


    /**
     * TABLE functions
     * ===================================================
     */
    function _tableFunctions($table) {
        $table.find('input.checkall[data-name]').on("click", function () {
            var parent = $(this).parents('table');
            if (!$(this).parents('table').length) {
                parent = $(this).parents("form");
            }
            parent.find(':checkbox[name^="' + $(this).attr("data-name") + '"]').prop("checked", this.checked);
            if (this.checked) {
                parent.find('tr').addClass('rowActive');
            } else {
                parent.find('tr').removeClass('rowActive');
            }
        });

        $table.find("tbody tr td input[type='checkbox']").click(function (e) {
            $(this).parent().parent().toggleClass('rowActive');
        });

        var $filter = $table.closest(".tab-content").find('.selectFilter');
        $filter.on("change", function (e) {
            var filterValue = $(this).val();
            var $pane = $(this).closest(".tab-pane");

            $.each($pane.find("tbody td:nth-child(3)"), function (key, value) {
                if (filterValue == "All") {
                    $(this).parent().removeClass("hide");
                } else {
                    if ($(this).text() != filterValue) {
                        $(this).parent().addClass("hide");
                    } else {
                        $(this).parent().removeClass("hide");
                    }
                }
            });
        });
    }// end function

    function _shiftClickCheckboxSelect($table) {
        var $chkboxes = $table.find("tbody tr td input[type='checkbox']");
        var lastChecked = null;

        $chkboxes.click(function (e) {
            if (!lastChecked) {
                lastChecked = this;
                return;
            }
            if (e.shiftKey) {
                var start = $chkboxes.index(this);
                var end = $chkboxes.index(lastChecked);
                $chkboxes.slice(Math.min(start, end), Math.max(start, end) + 1).prop('checked', lastChecked.checked);
            }
            lastChecked = this;
        });
    }// end function

    function _outputJsonTable(json, keyField) {
        var html = '';
        for (var i = 0; i < json.length; i++) {
            // First loop, create the column headers
            if (i === 0) {
                html += '<thead><tr>';
                $.each(json[i], function (key, value) {
                    if (key == keyField) {
                        html += '<th width="1"><input class="checkall" type="checkbox" data-name="selected" /></th>';
                    } else {
                        html += '<th>' + key + '</th>';
                    }
                });
                html += '</thead></tr>';
                html += '<tbody>';
            }


            // loop through all the json objects and for every key add a column with the value
            html += '<tr>';
            $.each(json[i], function (key, value) {
                if (key == keyField) {
                    html += '<td class="center"><input type="checkbox" name="selected[' + value + ']" data-serial-id="' + value + '" /></td>';
                } else {
                    html += '<td class="center">' + value + '</td>';
                }
            });
            html += '</tr>';
        }
        html += '</tbody>';
        return html;
    }// end function


    /**
     * FILE UPLOADER Callback functions
     * ===================================================
     */
    function resetFileUpload() {
        $("#output").empty();
        $("#output").addClass("hide");
    }// end function

    function afterSuccess() {
        $('#uploadSubmit').removeClass('hide'); // Show submit button
        $('#uploadCancel').removeClass('hide'); // Show submit button
        $('#loading-img').addClass('hide');     // Hide loading image button
        $('#output').removeClass('hide');       // Show
        $('#progressbox').delay(1000).fadeOut(); //hide progress bar

        // -- Initialise Barcode Button scanning -- //
        setupScanAction();
    }// end function

    function beforeSubmit() {
        $('#output').removeClass('hide'); // Show

        //check whether browser fully supports all File API
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            if (!$('#uploadFileInput').val()) { //check empty input filed
                $("#output").html("Please specify a file to upload");
                return false
            }

            var fsize = $('#uploadFileInput')[0].files[0].size; //get file size
            var ftype = $('#uploadFileInput')[0].files[0].type; // get file type

            //allow file types
            switch (ftype) {
                case 'image/png':
                case 'image/gif':
                case 'image/jpeg':
                case 'image/pjpeg':
                case 'text/plain':
                case 'text/html':
                case 'application/x-zip-compressed':
                case 'application/pdf':
                case 'application/msword':
                case 'application/vnd.ms-excel':
                case 'video/mp4':
                    break;
                default:
                    $("#output").html("<b>" + ftype + "</b> File type is unsupported.<br>Accepted file types: Jpeg, PNG, PDF, Docx, XLS, ZIP");
                    return false
            }

            //Allowed file size is less than 5 MB (1048576)
            if (fsize > 5242880) {
                $("#output").html("File size is too big, it should be less than 5 MB.<br>Attempted upload filesize <b>" + bytesToSize(fsize) + "</b> MB");
                return false
            }

            $('#uploadSubmit').addClass('hide');    // hide submit button
            $('#uploadCancel').addClass('hide');    // hide cancel button
            $('#loading-img').removeClass('hide');  // reveal Image Loading Spinner
            $("#output").html("");
        } else {
            //Output error to older unsupported browsers that doesn't support HTML5 File API
            $("#output").html("Please upgrade your browser, because your current browser lacks some new features we need!");
            return false;
        }
    }// end function (beforeSubmit)

    function OnProgress(event, position, total, percentComplete) {
        //Progress bar
        $('#progressbox').removeClass('hide');  // Show
        $('#progressbar').width(percentComplete + '%'); //update progressbar percent complete
        $('#statustxt').html(percentComplete + '%'); //update status text
        if (percentComplete > 50) {
            $('#statustxt').css('color', '#000'); //change status text to white after 50%
        }
    }// end function (OnProgress)

    //function to format bites bit.ly/19yoIPO
    function bytesToSize(bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Bytes';
        var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
    }// end function (bytesToSize)


    /**
     * MODAL functions
     * ===================================================
     */
    var $popme = $('#modal-popme');
    $('.popme').on('click', function (e) {
        e.preventDefault();

        var $self = $(this);

        if (!$popme.length) {
            var close_html = '';

            if ($self.data("close") == "yes" || $self.data("close") == 1) {
                close_html = '<button id="close" class="btn btn-default" data-dismiss="modal" aria-hidden="true">Close</button>';
                close_html += '&nbsp;<img class="qrcodeImg" src="' + HOME + TEMPLATE_HOME + '/img/qrcodes/action-close.jpg" />';
            }

            var modal_html = '<div class="modal fade" tabindex="-1" role="dialog">\
                                  <div class="modal-dialog">\
                                    <div class="modal-content">\
                                      <div class="modal-image"></div>\
                                      <div class="modal-header">\
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\
                                        <h4 class="modal-title"></h4>\
                                      </div>\
                                      <div class="modal-body"></div>\
                                    </div>\
                                  </div>\
                                </div>';
            $(modal_html).attr('id', 'modal-popme').appendTo($body);
            $popme = $('#modal-popme');
        }// endif (length)

        /* -- Jquery caches Data attributes -- */
        refreshPopmeAttributes($self);

        if ($self.data("size")) {
            $popme.find('.modal-dialog').addClass('modal-' + $self.data("size"));
        } else if ($self.data("width") && $self.data("height")) {
            $popme.find('.modal-dialog').css('width', $self.data("width"));
            $popme.find('.modal-body').css('height', $self.data("height"));
        }

        if ($self.data("title")) {
            $popme.find('.modal-title').html($self.data("title"));
        } else if ($self.attr("title")) {
            $popme.find('.modal-title').html($self.attr("title"));
        } else {
            $popme.find('.modal-title').html($self.text());
        }

        var href = '';
        if ($self.data("href")) {
            href = $self.data("href");
        } else if ($(e.target).attr('href')) {
            href = $(e.target).attr('href');
        } else if ($self.attr('href')) {
            href = $self.attr('href');
        }

        if (href) {
            if (href.indexOf('#') == 0) {
                // Open popup from inline HTML using ID
                $(href).modal('open');
            } else {
                // Load URL into iFrame
                var url = href + (href.indexOf('?') >= 0 ? "&" : '?') + 'output=modal';
                $popme.find(".modal-body")
                    .addClass('modal-iframe')
                    .css('height', 'auto')
                    .html('<iframe src="' + url + '" style="margin:0; padding:0; width:100%; height:' + ($self.data("height") ? $self.data("height") : 400) + 'px; display:block" frameborder="0" frameborder="0" hspace="0"></iframe>');

                $popme.modal();


                $popme.on('hide.bs.modal', function () {
                    $popme.find(".modal-iframe").empty();
                    // Trigger default <body> click
                    setTimeout(function () {
                        $("body").trigger("click");
                    }, 250);
                });
            }
        }
    });

    /**
     * Global Access Close Bootstrap Modal
     * Call from iframe with: window.parent.closeModal();
     */
    window.closeModal = function () {
        $popme.modal('hide');
    };

}); // doc.ready


/**
 * Function to refresh cached 'data' attributes if DOM value is different
 * @param self
 */
function refreshPopmeAttributes($self) {
    var popmeAttribute = ['size', 'width', 'height', 'title', 'href'];

    for (var i = 0; i < popmeAttribute.length; i++) {
        if (typeof $self.attr('data-' + popmeAttribute[i]) === 'undefined' || $self.attr('data-' + popmeAttribute[i]) === null) {
            // Do nothing - no attribute to update.
            // console.log("Popme attribute " + popmeAttribute[i] + " not found");
        } else {
            $self.data(popmeAttribute[i], $self.attr('data-' + popmeAttribute[i]));
        }
    }// end for
}// end function


decodeBase64 = function (s) {
    var e = {}, i, b = 0, c, x, l = 0, a, r = '', w = String.fromCharCode, L = s.length;
    var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0; i < 64; i++) {
        e[A.charAt(i)] = i;
    }
    for (x = 0; x < L; x++) {
        c = e[s.charAt(x)];
        b = (b << 6) + c;
        l += 6;
        while (l >= 8) {
            ((a = (b >>> (l -= 8)) & 0xff) || (x < (L - 2))) && (r += w(a));
        }
    }
    return r;
};

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

/**
 * Lightbox
 **/
$(".lightbox").each(function () {
    var $this = $(this);

    var title = $this.data('title');
    if (!title) {
        if (!title && $this.attr('title')) {
            title = $this.attr('title');
        }
        if (!title && $this.find('img').attr('alt')) {
            title = $this.find('img').attr('alt');
        }

        $this.data('title', title);
    }

    var html = $this.parents('section').find('.hidden-content').html();

    $this.data('footer', html);

    $this.on('click', function () {
        $(this).ekkoLightbox({
            showArrows: true,
            type: 'image',
            alwaysShowClose: true,
            width: '70vw',
            height: '70vh'
        });
        return false;
    });
});

/**
 * Filter file categories based on whether all or shipment
 */

if (document.getElementById('salesorder_files_shipment_id')) {
    function setDisabledCategories() {
        const shipment = document.getElementById('salesorder_files_shipment_id');
        const category = document.getElementById('salesorder_files_salesorder_file_description');
        category.querySelectorAll('option').forEach(option => {
            if (!option.dataset.disableifshipping) return;
            if (option.dataset.disableifshipping == shipment.value) {
                option.disabled = true;
            } else if (option.dataset.disableifshipping[0] == '!' && shipment.value !== option.dataset.disableifshipping.slice(1)) {
                option.disabled = true;
            } else {
                option.removeAttribute('disabled');
            }
        });
    }

    setDisabledCategories();
    document.getElementById('salesorder_files_shipment_id').addEventListener('change', setDisabledCategories);
}


/**
 *
 * Salesorder search
 *
 */
if (document.getElementById('salesorder-search')) {

    async function loadSearchContents() {
        const searchValue = document.querySelector('#salesorder-search input').value;
        const target = document.querySelector('#salesorder-search .search-results');
        const url = '/salesorder/search?output=modal&searchcolumns=salesorder_search.search_string&searchvalue=' + searchValue;

        if (searchValue.length >= 3) {
            try {
                target.style.display = 'block';
                target.setAttribute('aria-busy', true)
                const response = await fetch(url);

                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.statusText);
                }

                let html = await response.text();
                const placeholder = document.createElement('div');
                placeholder.innerHTML = html;

                html = placeholder.querySelector('form').innerHTML;

                target.innerHTML = html;
                target.removeAttribute('aria-busy');

                const searchInput = document.querySelector('.search-input');
                const searchMenu = document.querySelector('.search-results');
                const searchMenuItems = Array.from(searchMenu.querySelectorAll('a'));
                let active = -1

                function keyNavigateSearch(e) {
                    if (document.activeElement.closest('#salesorder-search')) {
                        switch (e.key) {
                            case 'ArrowDown':
                                e.preventDefault();
                                if (active < searchMenuItems.length - 1) {
                                    active++
                                    searchMenuItems[active].focus()
                                }
                                break;
                            case 'ArrowUp':
                                e.preventDefault();
                                if (active > 0) {
                                    active--
                                    searchMenuItems[active].focus()
                                } else {
                                    searchInput.focus();
                                }
                                break;
                            case 'Enter':
                                e.preventDefault();
                                if (document.activeElement.href){
                                    window.location.href = document.activeElement.href;
                                }
                                break;
                            case 'Escape':
                                target.innerHTML = '';
                                break;
                            default:
                                break;
                        }
                    } else {
                        target.innerHTML = '';
                    }
                }

                document.removeEventListener('keydown', keyNavigateSearch)
                document.addEventListener('keydown', keyNavigateSearch);

            } catch
                (error) {
                target.removeAttribute('aria-busy');
                console.error('Unable to fetch content for ' + target + 'from ' + url + ': ' + error.message);
            }

        } else {
            target.style.display = 'none';
        }

    }


    document.querySelector('#salesorder-search input').addEventListener('input', async () => await loadSearchContents());
    window.addEventListener('load', async () => await loadSearchContents());


}
